import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AchConfirmationDialogComponent } from '../ach-confirmation-dialog/ach-confirmation-dialog.component';
import { AchRemoveAccountComponent } from '../ach-remove-account/ach-remove-account.component';
import { MatButtonModule } from '@angular/material/button';
import { IBtUsBankAccount } from '../../interfaces/braintree.interfaces';


@Component({
  selector: 'equine-ui-nx-bt-ach-accounts',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule
  ],
  templateUrl: './bt-ach-accounts.component.html',
  styleUrl: './bt-ach-accounts.component.scss',
})
export class BtAchAccountsComponent {
  readonly dialog = inject(MatDialog);

  @Input() paymentMethods: IBtUsBankAccount[] = [];
  @Input() loading = false;
  @Input() verificationOnly = false;

  @Output() selected = new EventEmitter<{token: string}>();
  @Output() removed = new EventEmitter<{token: string}>();
  @Output() verified = new EventEmitter<IBtUsBankAccount>();

  removeAccount(token: string) {
    const dialogRef = this.dialog.open(AchRemoveAccountComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.removed.emit({token});
      }
    });
  }


  selectAccount(token: string) {
    const dialogRef = this.dialog.open(AchConfirmationDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selected.emit({token});
      }
    });
  }

  verify(account: IBtUsBankAccount) {
    this.verified.emit(account);
  }


}
